export const DMS_MODULE = 'Sestavy';
export const NAME = 'AccountReceivableReport';
export const EXPORT_FILE_NAME = 'AccountReceivable.xlsx';
export const CRUMB_LABEL_KEY = 'AccountReceivable';
export const ACCOUNT_RECIEVABLE = 'AccountReceivable'
